import React from "react";
import { ArrowDownRight } from "lucide-react";

const DashboardGlassCard = React.forwardRef(({ children, className, onClick, noHover, isEditMode, isMobile, variant = "glass", ...props }, ref) => (
  <div
    ref={ref}
    onClick={onClick}
    {...props}
    className={`
      relative overflow-hidden 
      ${variant === "solid" ? `bg-white rounded-[20px] border-none ${isMobile ? "" : "shadow-[0_2px_12px_rgba(0,0,0,0.06)]"}` : "rounded-[2.5rem] bg-white/60 backdrop-blur-3xl border border-white/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"}
      ${(!noHover && !isMobile) && "hover:shadow-2xl hover:-translate-y-2 hover:border-white/60 hover:bg-white/70 cursor-pointer active:scale-[0.98] transition-all duration-500 [transition-timing-function:cubic-bezier(0.34,1.56,0.64,1)]"}
      transition-all duration-500 ease-out
      ${className}
    `}
  >
    {variant !== "solid" && <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-transparent pointer-events-none"></div>}
    <div className="relative z-10 h-full flex flex-col">{children}</div>
    {isEditMode && (
      <div className="absolute bottom-1 right-1 p-2 bg-blue-100 rounded-full shadow-md pointer-events-none animate-pulse z-50">
        <ArrowDownRight size={24} className="text-blue-600" />
      </div>
    )}
  </div>
));

DashboardGlassCard.displayName = "DashboardGlassCard";

export default DashboardGlassCard;
